/* eslint-disable react/prop-types */
import React, { useState } from "react";

import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

import { useStyles } from "./termSheet.style";

import TermSheetTable from "./termSheetTable";
import AddIcon from "./assets/AddIcon.svg";

const TermSheetFeeDetails = (props) => {
  const classes = useStyles();
  const {
    feeDetails: feeDetailsData,
    termSheetConfig,
    sanitizeCurrency,
    isDownloadingTermSheet
  } = props;
  const {
    feeDetails: { config, handleFeeChange, handleDeleteFee, handleFeeBlur },
    isViewMode
  } = termSheetConfig;
  const [finalChunkedFeeDetails, setFinalChunkedFeeDetails] = useState([]);
  const [feeConfigTableData, setFeeConfigTableData] = useState([]);

  React.useEffect(() => {
    const returnFeeDetails = [];
    config?.forEach((feeConfig) => {
      if (feeConfig?.isVisible() && feeDetailsData[feeConfig.label]) {
        returnFeeDetails.push({
          mainLabel: feeConfig?.label,
          label: feeConfig?.label,
          value: feeDetailsData[feeConfig.label]
        });
      }
    });
    const tempFinalChunkedFeeDetails = [
      returnFeeDetails.slice(0, Math.ceil(returnFeeDetails.length / 2)) || [],
      returnFeeDetails.slice(Math.ceil(returnFeeDetails.length / 2)) || []
    ];
    setFeeConfigTableData(tempFinalChunkedFeeDetails);
  }, [config, feeDetailsData]);

  React.useEffect(() => {
    const chunkedFeeDetails = [];
    Object.keys(feeDetailsData).forEach((key) => {
      chunkedFeeDetails.push({
        label: key,
        value: sanitizeCurrency(feeDetailsData[key])
      });
    });

    const tempFinalChunkedFeeDetails = [
      chunkedFeeDetails.slice(0, chunkedFeeDetails.length / 2) || [],
      chunkedFeeDetails.slice(chunkedFeeDetails.length / 2) || []
    ];
    setFinalChunkedFeeDetails(tempFinalChunkedFeeDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [feeDetailsData]);

  return (
    <Grid item xs={12}>
      {!isViewMode && !isDownloadingTermSheet ? (
        <>
          <Grid container>
            {feeConfigTableData?.length
              ? feeConfigTableData?.map((feeConfig) => {
                  return (
                    <Grid item xs={6}>
                      <TermSheetTable
                        loanData={feeConfig}
                        isFeeDetails
                        handleDeleteFee={handleDeleteFee}
                        feeDetailsData={feeDetailsData}
                        handleFeeChange={handleFeeChange}
                        handleFeeBlur={handleFeeBlur}
                      />
                    </Grid>
                  );
                })
              : null}
          </Grid>
          <Button
            variant='outlined'
            color='primary'
            className={classes.requirementBtn}
            onClick={() => {
              return props?.setOpenFeeDrawer(true);
            }}
          >
            <img src={AddIcon} alt='add-icon.svg' /> &ensp; Add Fee
          </Button>
        </>
      ) : (
        <Grid container>
          {finalChunkedFeeDetails?.map((loan) => {
            return (
              <Grid item xs={6} key={loan?.label}>
                <TermSheetTable loanData={loan} />
              </Grid>
            );
          })}
        </Grid>
      )}
    </Grid>
  );
};

export default React.memo(TermSheetFeeDetails);
